'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setInReplyToId = exports.setRichText = exports.setText = exports.setSenderType = exports.setContentType = exports.setAttachments = exports.setTimestamp = exports.setMessageDeletedStatus = exports.setMessageStatusTimestamp = exports.setMessageStatusSouce = exports.setMessageStatus = exports.setStatus = exports.setId = undefined;

var _setIn = require('transmute/setIn');

var _setIn2 = _interopRequireDefault(_setIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setId = exports.setId = (0, _setIn2.default)(_keyPaths.ID);

var setStatus = exports.setStatus = (0, _setIn2.default)(_keyPaths.STATUS);

var setMessageStatus = exports.setMessageStatus = (0, _setIn2.default)(_keyPaths.MESSAGE_STATUS);

var setMessageStatusSouce = exports.setMessageStatusSouce = (0, _setIn2.default)(_keyPaths.MESSAGE_STATUS_SOURCE);

var setMessageStatusTimestamp = exports.setMessageStatusTimestamp = (0, _setIn2.default)(_keyPaths.MESSAGE_STATUS_TIMESTAMP);

var setMessageDeletedStatus = exports.setMessageDeletedStatus = (0, _setIn2.default)(_keyPaths.MESSAGE_DELETE_STATUS);

var setTimestamp = exports.setTimestamp = (0, _setIn2.default)(_keyPaths.TIMESTAMP);

var setAttachments = exports.setAttachments = (0, _setIn2.default)(_keyPaths.ATTACHMENTS);

var setContentType = exports.setContentType = (0, _setIn2.default)(_keyPaths.CONTENT_TYPE);

var setSenderType = exports.setSenderType = (0, _setIn2.default)(_keyPaths.SENDER_TYPE);

var setText = exports.setText = (0, _setIn2.default)(_keyPaths.TEXT);

var setRichText = exports.setRichText = (0, _setIn2.default)(_keyPaths.RICH_TEXT);

var setInReplyToId = exports.setInReplyToId = (0, _setIn2.default)(_keyPaths.IN_REPLY_TO_ID);